import { generateShortDateString } from "@/domains/date/date";
import { LensKind, SortByKind } from "@/modules/lenses/types";
import { CollectionObservable } from "@/store/collections/CollectionObservable";
import { CollectionSearchSortByKind } from "@/store/collections/types";

export const collectionsLensSortFunctionMap: {
  [key in CollectionSearchSortByKind]: (a: CollectionObservable, b: CollectionObservable) => number;
} = {
  [SortByKind.LastModified]: (a, b) =>
    new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime(),
  [SortByKind.LastCreated]: (a, b) =>
    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  [SortByKind.LastViewed]: (a, b) =>
    new Date(b.spaceAccountCollection?.lastViewedAt || b.createdAt).getTime() -
    new Date(a.spaceAccountCollection?.lastViewedAt || a.createdAt).getTime(),
  [SortByKind.Alphabetical]: (a, b) => a.label.localeCompare(b.label),
  [SortByKind.LastShared]: (a, b) =>
    new Date(b.sharedWithMeAt).getTime() - new Date(a.sharedWithMeAt).getTime(),
};

export const collectionsLensDateLabelMap: {
  [key in CollectionSearchSortByKind]: (collection: CollectionObservable) => string;
} = {
  [SortByKind.LastModified]: collection => generateShortDateString(collection.modifiedAt),
  [SortByKind.LastCreated]: collection => generateShortDateString(collection.createdAt),
  [SortByKind.LastViewed]: collection =>
    generateShortDateString(
      collection.spaceAccountCollection?.lastViewedAt || collection.createdAt
    ),
  [SortByKind.Alphabetical]: collection => generateShortDateString(collection.modifiedAt),
  [SortByKind.LastShared]: collection => generateShortDateString(collection.sharedWithMeAt),
};

export const collectionsLensFilterFunctionMap: {
  [key in LensKind]: (collection: CollectionObservable) => boolean;
} = {
  [LensKind.All]: () => true,
  [LensKind.AddedByMe]: collection => collection.isOwnedByMe,
  [LensKind.SharedWithMe]: collection => !collection.isOwnedByMe,
};
